import React, { useRef, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useClickOutside } from '../hooks/useClickOutside';

export function ServiceDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { t } = useLanguage();

  useClickOutside(dropdownRef, () => setIsOpen(false));

  const services = [
    { id: 'whatsapp',            nameKey: 'nav.service.whatsapp' },
    { id: 'business-automation', nameKey: 'nav.service.business' },
    { id: 'data-analysis',       nameKey: 'nav.service.data' },
    { id: 'chatbots',            nameKey: 'nav.service.chatbots' },
    { id: 'logistics',           nameKey: 'nav.service.logistics' },
    { id: 'marketing',           nameKey: 'nav.service.marketing' },
  ];

  const handleServiceClick = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}
        className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-primary transition-colors duration-300 w-full md:w-auto text-sm font-medium"
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        <span>{t('nav.services')}</span>
        {isOpen ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>

      {isOpen && (
        <div
          className="absolute z-50 mt-2 w-72 bg-white rounded-lg shadow-xl border border-gray-100 py-2 right-0 md:right-auto"
          role="menu"
          onClick={(e) => e.stopPropagation()}
        >
          {services.map((s) => (
            <button
              key={s.id}
              onClick={() => handleServiceClick(s.id)}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-primary hover:text-white transition-colors duration-200"
              role="menuitem"
            >
              {t(s.nameKey)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
